import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { unit_type, bool_type, lambda_type, class_type, tuple_type, option_type, record_type, list_type, union_type, string_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { FileManagementUpdateArgs_$reflection } from "../../../FileManagement/FileManagementTypes.js";
import { UserRole_$reflection } from "../../../RAWMap.Models/Security.js";
import { CustomReportStatus_$reflection, CustomReportMetadataViewModel_$reflection, CustomReportViewModel_$reflection } from "../../../RAWMap.Models/View/CustomReport.js";
import { StudyViewModel_$reflection } from "../../../RAWMap.Models/View/Study.js";
import { PatientCreationViewModel_$reflection, PatientViewModel_$reflection } from "../../../RAWMap.Models/View/Patient.js";
import { InstitutionViewModel_$reflection } from "../../../RAWMap.Models/View/Institution.js";
import { AnalysisViewModel_$reflection } from "../../../RAWMap.Models/View/Analysis.js";
import { FSharpChoice$2 } from "../../../fable_modules/fable-library-js.4.19.3/Choice.js";
import { Common_GeneratedReportType_$reflection, Common_ReportType_$reflection } from "../../../RAWMap.Models/Common.js";
import { ErrorMessage_$reflection } from "../../../RAWMap.Models/ErrorMessage.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.3/Result.js";

export class PromptType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Create", "Download", "Delete"];
    }
}

export function PromptType_$reflection() {
    return union_type("RAWMap.Client.Study.CustomReport.Prompt.Types.PromptType", [], PromptType, () => [[], [["path", string_type]], [["path", string_type]]]);
}

export class ReportPromptUpdateArgs extends Record {
    constructor(fileArgs, userRoles, customReport) {
        super();
        this.fileArgs = fileArgs;
        this.userRoles = userRoles;
        this.customReport = customReport;
    }
}

export function ReportPromptUpdateArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomReport.Prompt.Types.ReportPromptUpdateArgs", [], ReportPromptUpdateArgs, () => [["fileArgs", FileManagementUpdateArgs_$reflection()], ["userRoles", list_type(UserRole_$reflection())], ["customReport", CustomReportViewModel_$reflection()]]);
}

export class ReportPromptInitArgs extends Record {
    constructor(selectedStudy, selectedPatient, patientInstitution, studyAnalysis, maybePreviousStudy, geometryData, growthData, maybeCurrentStudyAcquisitionDate, maybePreviousStudyAcquisitionDate, initUserRoles, promptType, analysisRevision) {
        super();
        this.selectedStudy = selectedStudy;
        this.selectedPatient = selectedPatient;
        this.patientInstitution = patientInstitution;
        this.studyAnalysis = studyAnalysis;
        this.maybePreviousStudy = maybePreviousStudy;
        this.geometryData = geometryData;
        this.growthData = growthData;
        this.maybeCurrentStudyAcquisitionDate = maybeCurrentStudyAcquisitionDate;
        this.maybePreviousStudyAcquisitionDate = maybePreviousStudyAcquisitionDate;
        this.initUserRoles = initUserRoles;
        this.promptType = promptType;
        this.analysisRevision = analysisRevision;
    }
}

export function ReportPromptInitArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomReport.Prompt.Types.ReportPromptInitArgs", [], ReportPromptInitArgs, () => [["selectedStudy", StudyViewModel_$reflection()], ["selectedPatient", PatientViewModel_$reflection()], ["patientInstitution", InstitutionViewModel_$reflection()], ["studyAnalysis", AnalysisViewModel_$reflection()], ["maybePreviousStudy", option_type(StudyViewModel_$reflection())], ["geometryData", option_type(list_type(tuple_type(string_type, string_type)))], ["growthData", option_type(list_type(tuple_type(string_type, string_type)))], ["maybeCurrentStudyAcquisitionDate", option_type(string_type)], ["maybePreviousStudyAcquisitionDate", option_type(string_type)], ["initUserRoles", list_type(UserRole_$reflection())], ["promptType", PromptType_$reflection()], ["analysisRevision", string_type]]);
}

export class SaveReportArgs extends Record {
    constructor(metadata) {
        super();
        this.metadata = metadata;
    }
}

export function SaveReportArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomReport.Prompt.Types.SaveReportArgs", [], SaveReportArgs, () => [["metadata", option_type(CustomReportMetadataViewModel_$reflection())]]);
}

export class Operation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DownloadingReportPdf", "GeneratingReportPdf", "UploadingReportPdf", "UpdatingMetadata", "ValidatingPatientInfo", "SavingReportPdf", "DeletingReportPdf"];
    }
}

export function Operation_$reflection() {
    return union_type("RAWMap.Client.Study.CustomReport.Prompt.Types.Operation", [], Operation, () => [[], [], [], [], [], [], []]);
}

export function Operation_display_Z518F1114(operation) {
    switch (operation.tag) {
        case 1:
            return "Generating Report";
        case 2:
            return "Uploading Report";
        case 3:
            return "Updating Metadata";
        case 4:
            return "Validating Patient Info";
        case 5:
            return "Saving Report";
        case 6:
            return "Deleting Report";
        default:
            return "Downloading Report";
    }
}

export class Mode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Review", "RunningOperation"];
    }
}

export function Mode_$reflection() {
    return union_type("RAWMap.Client.Study.CustomReport.Prompt.Types.Mode", [], Mode, () => [[], [["Item", Operation_$reflection()]]]);
}

export function ModeModule_$007CDisableButtons$007CEnableButtons$007C(mode) {
    if (mode.tag === 0) {
        return new FSharpChoice$2(1, [undefined]);
    }
    else {
        return new FSharpChoice$2(0, [Operation_display_Z518F1114(mode.fields[0])]);
    }
}

export function ModeModule_$007CSpinner$007CNoSpinner$007C(mode) {
    if (mode.tag === 0) {
        return new FSharpChoice$2(1, [undefined]);
    }
    else {
        return new FSharpChoice$2(0, [Operation_display_Z518F1114(mode.fields[0])]);
    }
}

export class ModelReportPrompt extends Record {
    constructor(SelectedStudy, StudyAnalysis, MaybePreviousStudy, GeometryData, GrowthData, MaybeCurrentStudyAcquisitionDate, MaybePreviousStudyAcquisitionDate, PromptType, Mode, UserRoles, PatientCreationInfo, ReportTypeToGenerate, GeneratedReportType, AnalysisRevision) {
        super();
        this.SelectedStudy = SelectedStudy;
        this.StudyAnalysis = StudyAnalysis;
        this.MaybePreviousStudy = MaybePreviousStudy;
        this.GeometryData = GeometryData;
        this.GrowthData = GrowthData;
        this.MaybeCurrentStudyAcquisitionDate = MaybeCurrentStudyAcquisitionDate;
        this.MaybePreviousStudyAcquisitionDate = MaybePreviousStudyAcquisitionDate;
        this.PromptType = PromptType;
        this.Mode = Mode;
        this.UserRoles = UserRoles;
        this.PatientCreationInfo = PatientCreationInfo;
        this.ReportTypeToGenerate = ReportTypeToGenerate;
        this.GeneratedReportType = GeneratedReportType;
        this.AnalysisRevision = AnalysisRevision;
    }
}

export function ModelReportPrompt_$reflection() {
    return record_type("RAWMap.Client.Study.CustomReport.Prompt.Types.ModelReportPrompt", [], ModelReportPrompt, () => [["SelectedStudy", StudyViewModel_$reflection()], ["StudyAnalysis", AnalysisViewModel_$reflection()], ["MaybePreviousStudy", option_type(StudyViewModel_$reflection())], ["GeometryData", option_type(list_type(tuple_type(string_type, string_type)))], ["GrowthData", option_type(list_type(tuple_type(string_type, string_type)))], ["MaybeCurrentStudyAcquisitionDate", option_type(string_type)], ["MaybePreviousStudyAcquisitionDate", option_type(string_type)], ["PromptType", PromptType_$reflection()], ["Mode", Mode_$reflection()], ["UserRoles", list_type(UserRole_$reflection())], ["PatientCreationInfo", PatientCreationViewModel_$reflection()], ["ReportTypeToGenerate", option_type(Common_ReportType_$reflection())], ["GeneratedReportType", Common_GeneratedReportType_$reflection()], ["AnalysisRevision", string_type]]);
}

export function ModelReportPrompt_get_reportTypeToGenerate_() {
    return [(m) => m.ReportTypeToGenerate, (v) => ((m_1) => (new ModelReportPrompt(m_1.SelectedStudy, m_1.StudyAnalysis, m_1.MaybePreviousStudy, m_1.GeometryData, m_1.GrowthData, m_1.MaybeCurrentStudyAcquisitionDate, m_1.MaybePreviousStudyAcquisitionDate, m_1.PromptType, m_1.Mode, m_1.UserRoles, m_1.PatientCreationInfo, v, m_1.GeneratedReportType, m_1.AnalysisRevision)))];
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExnErrorMsg", "SetPatientCreationVm", "SetModel", "VerifyPatientInfoResult", "TryPerformReportAction", "CancelReportGenerationOrDownload", "DownloadReport", "DownloadReportResult", "CreateReport", "CreateReportResult", "UploadReport", "UploadReportResult", "UpdateReportMetadata", "UpdateReportMetadataResult", "PrependTitlePage", "PrependTitlePageResult", "DeleteReport", "DeleteReportResult"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CustomReport.Prompt.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [["Item", lambda_type(PatientCreationViewModel_$reflection(), PatientCreationViewModel_$reflection())]], [["Item", lambda_type(ModelReportPrompt_$reflection(), ModelReportPrompt_$reflection())]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [SaveReportArgs_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", SaveReportArgs_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("RAWMap.Client.Bindings.Pdf.JsPdf.JsPdfCore.Jspdf.jsPDF"), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", class_type("RAWMap.Client.Bindings.Pdf.JsPdf.JsPdfCore.Jspdf.jsPDF")]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", class_type("RAWMap.Client.Bindings.Pdf.JsPdf.JsPdfCore.Jspdf.jsPDF")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [SaveReportArgs_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", SaveReportArgs_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", SaveReportArgs_$reflection()]], [["Item1", SaveReportArgs_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [CustomReportStatus_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", CustomReportStatus_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", SaveReportArgs_$reflection()]], [["Item1", SaveReportArgs_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [["Item1", SaveReportArgs_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [CustomReportStatus_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", CustomReportStatus_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])]]]);
}

export class InboundMsg {
    constructor() {
    }
}

export function InboundMsg_$reflection() {
    return class_type("RAWMap.Client.Study.CustomReport.Prompt.Types.InboundMsg", undefined, InboundMsg);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CancelCustomReport", "UpdateCustomReportStatus", "ReportFinished"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CustomReport.Prompt.Types.OutboundMsg", [], OutboundMsg, () => [[], [["Item", CustomReportStatus_$reflection()]], [["Item", option_type(CustomReportMetadataViewModel_$reflection())]]]);
}

